// Show/Hide Product Lightbox
document.addEventListener("DOMContentLoaded", function () {
  // Select all LM-product-image elements
  var productImages = document.querySelectorAll(".lm-product-image");

  // Add click event listener to each LM-product-image
  productImages.forEach(function (image) {
    image.addEventListener("click", function () {
      // Display the lightbox
      showOverlay();
    });
  });

  // Add click event listener to the close button
  var closeButton = document.querySelector(".lm-product-lightbox-close");
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      // Hide the lightbox
      hideOverlay();
    });
  }

  // Function to display the lightbox
  function showOverlay() {
    var lightbox = document.querySelector(".lm-product-lightbox");

    // Check if the lightbox exists
    if (lightbox) {
      lightbox.style.opacity = 1;
      lightbox.style.visibility = "visible";

      document.body.style.overflow = "hidden";
    }
  }

  // Function to hide the lightbox
  function hideOverlay() {
    var lightbox = document.querySelector(".lm-product-lightbox");

    // Check if the lightbox exists
    if (lightbox) {
      lightbox.style.opacity = 0;
      lightbox.style.visibility = "hidden";

      document.body.style.overflow = "auto";
    }
  }
});
